import type {Post} from '@mattermost/types/posts';
import {getDmUsers} from 'mattermost-redux/selectors/entities/getDmUsers';
import type {AppDispatch} from 'stores/redux_store';
import {getCurrentUserId, getUsers} from 'mattermost-redux/selectors/entities/common';
import {getStatusesByIds} from 'mattermost-redux/actions/users';
import {type ActionFunc} from 'mattermost-redux/types/actions';
import {getChannel, selectDmUsersForSidebar} from 'mattermost-redux/selectors/entities/channels';
import {ChannelType} from '@mattermost/types/channels';
import {getUserIdFromChannelName} from 'mattermost-redux/utils/channel_utils';

export const getUserStatusesForPosts = (posts: Post[]): ActionFunc =>
    async (doDispatch, getState) => {
        const state = getState();
        const dispatch = doDispatch as AppDispatch;

        if (posts.length === 0) {
            return {data: true};
        }

        const currentUserId = getCurrentUserId(state);
        const users = getUsers(state);
        const allDmUsers = getDmUsers(state);
        const dmUsersInSidebar = selectDmUsersForSidebar(state);

        const userIdsToLoadStatusesFor: string[] = [];

        for (const post of posts) {
            const channel = getChannel(state, post.channel_id);

            /**
             * Не запрашиваем обновление статусов, если пост не в личку
             */
            if (channel?.type !== ChannelType.Direct) {
                continue;
            }

            const teammateId = getUserIdFromChannelName(currentUserId, channel.name);

            // Текущий пользователь у нас и так есть
            if (teammateId === currentUserId) {
                continue;
            }

            /**
             * Ботов исключаем, у них статусов нет
             */
            if (users[teammateId]?.is_bot) {
                continue;
            }

            /**
             * Статус нужно запросить только для тех пользователей, с которыми у текущего пользователя есть диалоги
             */
            if (!allDmUsers.has(teammateId)) {
                continue;
            }

            /**
             * Не запрашиваем статус, если пользователь уже отображается в сайдбаре.
             * Статус обновится по интервалу в 1 мин.
             */
            if (dmUsersInSidebar.has(teammateId)) {
                continue;
            }

            userIdsToLoadStatusesFor.push(teammateId);
        }

        if (userIdsToLoadStatusesFor.length > 0) {
            try {
                await dispatch(getStatusesByIds(userIdsToLoadStatusesFor));
            } catch (error) {
                return {data: false, error};
            }
        }

        return {data: true};
    };
